import React, { memo, useState } from 'react';

import { Typography } from 'antd';
import { FaChevronDown } from 'react-icons/fa6';
import { BottomSheet } from 'react-spring-bottom-sheet';

import Header from '../../../components/Header/Header';
import { useAppSelector } from '../../../shared/hooks';
import { formatName } from '../../../shared/utils';
import CommunityChannelPostList from '../../Community/CommunityPost/CommunityChannelPostList';
import CommunityPostLikedByUsersModal from '../../Community/CommunityPost/CommunityPostItems/CommunityPostLikedByUsersModal';
import PostsList from '../../Feed/Posts/PostsList';
import { IUserProfileDetails } from '../types';

interface Props {
  userId: string;
  isUserProfilePage?: boolean;
  profileDetails: IUserProfileDetails;
}

const UserProfilePosts: React.FC<Props> = ({
  userId,
  isUserProfilePage,
  profileDetails,
}) => {
  const {
    hostMetadata: { isCommunityFeatureActive },
  } = useAppSelector((state) => state.app);

  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<'Community' | 'Feed'>(
    isCommunityFeatureActive ? 'Community' : 'Feed',
  );

  return (
    <>
      <div className="user-profile-posts">
        <Typography.Title
          level={5}
          style={{ margin: 12 }}
          onClick={() => {
            setIsMenuVisible(true);
          }}>
          {isCommunityFeatureActive ? (
            <>
              {selectedTab} Posts <FaChevronDown />
            </>
          ) : (
            'Feed Posts'
          )}
        </Typography.Title>

        {selectedTab === 'Feed' ? (
          <PostsList
            userId={userId}
            isUserProfilePage={isUserProfilePage}
            showUserPosts
            noPostsMessage={`Posts from ${formatName(
              profileDetails.userProfile.name,
              {
                nameType: 'first',
                caseType: 'title',
              },
            )} will appear here.`}
          />
        ) : null}

        {selectedTab === 'Community' ? (
          <>
            <CommunityChannelPostList userId={userId} />
            <CommunityPostLikedByUsersModal />
          </>
        ) : null}
      </div>

      <BottomSheet
        open={isMenuVisible}
        onDismiss={() => {
          setIsMenuVisible(false);
        }}
        header={<Header title="Select post type" canGoBack={false} noBorder />}>
        <div
          className="user-profile-posts-menu"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            padding: 12,
          }}>
          <Typography.Text
            style={{ margin: 6 }}
            onClick={() => {
              setSelectedTab('Feed');
              setIsMenuVisible(false);
            }}>
            Feed Posts
          </Typography.Text>

          <Typography.Text
            style={{ margin: 6 }}
            onClick={() => {
              setSelectedTab('Community');
              setIsMenuVisible(false);
            }}>
            Community Posts
          </Typography.Text>
        </div>
      </BottomSheet>
    </>
  );
};

export default memo(UserProfilePosts);
